/* Shopelya — champ de personnalisation. Ajouté et élargi le 23/08/2026.
   S'insère dans le formulaire d'ajout au panier des produits portant le tag
   « personnalise ». La valeur part en propriété de ligne Shopify et apparaît
   sous le produit dans la commande.

   Deux modes, choisis dans le snippet Liquid selon les tags du produit :
   - « nom »   : prénom court, lettres uniquement (bijoux gravés)
   - « texte » : texte libre plus long, chiffres et ponctuation simple admis
                 (autocollant de mariage : prénoms + date)

   Le filtre est un garde-fou, pas une sécurité : il s'exécute dans le
   navigateur et reste contournable. La relecture avant gravure reste
   indispensable.

   🔴 RÈGLE PERMANENTE — cette liste ne contient que des injures.
   Aucun mot de langue, de religion, de nationalité ou d'appartenance ne doit
   y être ajouté : « arabe », « juif », « halal », « casher », « musulman »,
   « djihad » sont des mots neutres et n'ont rien à y faire.
   « Bougnoule » oui, « arabe » non — c'est toute la différence.

   ARBITRAGE — un faux positif coûte plus cher qu'un faux négatif.
   Un terme bloqué à tort humilie un client et fait perdre la vente, sans
   recours possible. Une injure qui passe est rattrapée à la relecture avant
   gravure. En cas de doute, ne pas ajouter le terme.

   Termes volontairement ÉCARTÉS après test, malgré leur usage injurieux :
   - « mongol », « gogol » : gentilé et nom propre avant d'être des insultes
     (« Mongolie » était bloqué à tort)
   - « polack », « raton » : « Polack » est un nom de famille répandu,
     « raton » apparaît dans des noms communs
   Contre-exemples déjà couverts par la règle des mots courts :
   « Isis », « Constance » (« con »), « Garcia » (« garce »), « Tara ». */
(function () {
  'use strict';

  var CFG = window.ShopelyaPerso || {};
  var LABEL = CFG.label || 'Prénom à graver';
  var MAX = CFG.max || 20;
  var MODE = CFG.mode || 'nom';
  var HINT = CFG.hint || 'L’orthographe que vous saisissez est celle qui sera gravée. Relisez-la avant de valider.';
  var MIN = 2;

  var BLOCKED = [
    /* Grossièretés courantes */
    'merde','merdique','merdeux','con','conne','connard','conard','connasse',
    'salope','salaud','salopard','pute','putain','ptn','encule','enculee',
    'batard','nique','niquer','ntm','fdp','foutre','chier','chiotte','pisse',
    'caca','pipi','crotte',
    /* Insultes à la personne */
    'abruti','cretin','debile','imbecile','enfoire','ordure','raclure',
    'crevure','charogne','pourriture','tocard','tare','attarde','trisomique',
    'bouffon','guignol','boloss','cassos','clochard','pouilleux','grognasse',
    'garce','catin','morue','thon','boudin','michto',
    /* Sexuel et corporel */
    'bite','teub','zboub','couille','burne','chatte','cul','anus','sexe',
    'penis','vagin','nichon','sperme','sodomie','fellation','masturb',
    'ejacul','erection','porno','baise','baiser','suce','suceuse',
    /* Homophobe et transphobe */
    'pede','tapette','tarlouze','gouine','fiotte','tafiole','travelo',
    /* Racistes et antisémites */
    'negre','negro','nigger','nigga','bougnoule','bicot','youpin','feuj',
    'bamboula','chink','niakoue','chinetoque','rital','boche',
    /* Haine et violence */
    'hitler','nazi','fuhrer','siegheil','swastika','kkk','daesh','terroriste',
    'attentat','violer','pedophile','pedo','egorge','egorger','suicide',
    'tuer','creve','crever',
    /* Anglais */
    'fuck','fucking','shit','bitch','asshole','cunt','whore','slut','dick',
    'pussy','bastard','motherfucker','wanker','twat','prick','bollocks',
    'faggot','retard','cock','tits','boobs','blowjob','jerkoff'
  ];

  function fold(s) {
    var t = String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    t = t.replace(/0/g, 'o').replace(/[1!|]/g, 'i').replace(/3/g, 'e');
    t = t.replace(/[4@]/g, 'a').replace(/[5$]/g, 's').replace(/7/g, 't');
    t = t.replace(/[^a-z ]/g, ' ');
    t = t.replace(/(.)\1+/g, '$1');
    return t.replace(/ +/g, ' ').trim();
  }

  function isBlocked(value) {
    var words = fold(value).split(' ');
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (!w) continue;
      for (var j = 0; j < BLOCKED.length; j++) {
        var b = BLOCKED[j];
        /* Les termes de 4 lettres ou moins ne correspondent qu'à un mot entier,
           faute de quoi « Constance » serait rejeté à cause de « con ». */
        if (b.length <= 4 ? w === b : w.indexOf(b) !== -1) return true;
      }
    }
    return false;
  }

  /* Mode « nom » : commence et finit par une lettre, séparateurs encadrés.
     « Jean-Pierre », « N’Guyen », « Aïcha », « محمد » passent.
     « . », « !!! », « --- », « A- » sont refusés.
     Mode « texte » : chiffres, virgule, point et esperluette admis en plus,
     mais au moins une lettre reste exigée — « 27 » seul ne passe pas.
     \p{L} couvre toutes les écritures : l'arabe doit passer. */
  var SHAPE = MODE === 'texte'
    ? /^[\p{L}\p{N}][\p{L}\p{M}\p{N} '’&,.\-]*[\p{L}\p{M}\p{N}.]$/u
    : /^\p{L}[\p{L}\p{M}]*(?:[ '’-][\p{L}\p{M}]+)*$/u;
  var HAS_LETTER = /\p{L}/u;

  function stop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  function attach(form) {
    if (form.querySelector('.shopelya-perso')) return;

    var wrap = document.createElement('div');
    wrap.className = 'shopelya-perso';
    wrap.innerHTML =
      '<label class="shopelya-perso__label" for="shopelya-perso-field"></label>' +
      '<input class="shopelya-perso__input" id="shopelya-perso-field" type="text"' +
      ' maxlength="' + MAX + '" autocomplete="off" spellcheck="false">' +
      '<p class="shopelya-perso__hint"></p>' +
      '<p class="shopelya-perso__error" role="alert" hidden></p>';

    /* textContent plutôt qu'innerHTML pour le libellé et l'aide : ils viennent
       de Liquid et ne doivent jamais être interprétés comme du HTML. */
    wrap.querySelector('.shopelya-perso__label').textContent = LABEL;
    wrap.querySelector('.shopelya-perso__hint').textContent = HINT;

    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.parentNode) btn.parentNode.insertBefore(wrap, btn);
    else form.appendChild(wrap);

    var input = wrap.querySelector('.shopelya-perso__input');
    input.setAttribute('name', 'properties[' + LABEL + ']');
    var err = wrap.querySelector('.shopelya-perso__error');

    function fail(msg, e) {
      err.textContent = msg;
      err.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      stop(e);
      input.focus();
    }

    input.addEventListener('input', function () {
      err.hidden = true;
      err.textContent = '';
      input.removeAttribute('aria-invalid');
    });

    form.addEventListener('submit', function (e) {
      var v = input.value.replace(/ +/g, ' ').trim();
      if (!v) return fail('Ce champ est obligatoire.', e);
      if (v.length < MIN) return fail('Indiquez au moins ' + MIN + ' caractères.', e);
      if (v.length > MAX) return fail(MAX + ' caractères au maximum.', e);
      /* Le filtre passe avant le contrôle de forme : sinon « c0nnard »
         renverrait « lettres uniquement », ce qui revient à souffler la
         bonne orthographe. */
      if (isBlocked(v)) return fail('Ce texte ne peut pas être gravé. Merci d’indiquer un autre texte.', e);
      if (!HAS_LETTER.test(v)) return fail('Le texte doit contenir des lettres.', e);
      if (!SHAPE.test(v)) {
        return fail(MODE === 'texte'
          ? 'Lettres, chiffres et ponctuation simple uniquement.'
          : 'Lettres uniquement. Le tiret et l’apostrophe sont admis entre deux lettres.', e);
      }
      input.value = v;
    }, true);
  }

  function scan() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) attach(forms[i]);
  }

  function start() {
    scan();
    /* Le formulaire peut être re-rendu au changement de variante. */
    var tries = 0;
    var timer = setInterval(function () {
      scan();
      if (++tries >= 12) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
